const styles = theme => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  title: {
    fontSize: '18px',
    fontWeight: 600,
    marginBottom: theme.spacing(3),
  },
  subtitle: {
    fontSize: '14px',
    color: '#637381',
    marginBottom: theme.spacing(1),
  },
  autocomplete: {
    '& .MuiOutlinedInput-root': {
      borderRadius: '8px',
      '& fieldset': {
        borderColor: '#E0E3E7',
      },
      '&:hover fieldset': {
        borderColor: '#B2BAC2',
      },
      '&.Mui-focused fieldset': {
        borderColor: theme.palette.primary.main,
      },
    },
  },
  titlePaper: {
    fontSize: '14px',
    fontWeight: 400,
    margin: '16px 0px',
  },
  titlePaperPage: {
    fontSize: '14px',
    fontWeight: 400,
  },
  optionText: {
    fontSize: '14px',
    color: '#212B36',
  },
  radioGroup: {
    marginTop: theme.spacing(2),
  },
  radio: {
    '&.Mui-checked': {
      color: theme.palette.primary.main,
    },
  },
  scrollableContainer: {
    maxHeight: 300,
    overflow: 'auto',
    '&.error': {
      borderColor: '#f44336',
    },
  },
  listContainer: {
    padding: 0,
  },
  divider: {
    margin: '8px 0',
  },
  pdfListItem: {
    padding: '8px 16px',
  },
  pdfFileName: {
    fontSize: '14px',
    fontWeight: 600,
    color: '#637381',
  },
  listItemIcon: {
    marginRight: 0,
  },
  contentListItem: {
    fontSize: '14px',
  },
  helperTextError: {
    color: '#f44336',
  },
  helperTextNormal: {
    color: '#637381',
  },
  pageTypeContainer: {
    marginBottom: theme.spacing(2),
  },
  errorText: {
    color: '#f44336',
    fontSize: '12px',
    marginTop: '8px',
  },
})

export default styles
